import React from "react";
import { ComposedChart, Bar, Line, XAxis, YAxis, Tooltip, ResponsiveContainer, CartesianGrid } from "recharts";
import { CardShell, EmptyRow, LoadingRow, unwrapValue, useCxoResource, asText } from "../shared";

// Shared by Ad set detail and Ad creative detail's own "Overview tab (chart)"
// — "same shape as the campaign overview" per the doc, but just the time
// series (no top-performer/contribution/audience-snapshot cards those only
// make sense one level up, where there are children to roll up).
const SimpleOverviewTab: React.FC<{ basePath: string; entityId: string; baseParams: Record<string, any> }> = ({ basePath, entityId, baseParams }) => {
  const { data, loading } = useCxoResource<any>(basePath, `${entityId}/overview`, { ...baseParams, granularity: "daily" }, !!entityId);
  const series: any[] = Array.isArray(data?.series) ? data.series : [];

  if (loading && !data) return <LoadingRow label="Loading performance…" />;
  if (!data || series.length === 0) return <EmptyRow label="No performance series for this period yet." />;

  return (
    <CardShell title="Performance over time" description="Track spend, results and efficiency across the selected period.">
      <div className="h-64">
        <ResponsiveContainer width="100%" height="100%">
          <ComposedChart data={series.map((s) => ({ date: asText(s.date), spend: unwrapValue(s.spend) || 0, results: unwrapValue(s.results) || 0, cost_per_result: unwrapValue(s.cost_per_result) || 0 }))} margin={{ top: 10, right: 10, left: -10, bottom: 0 }}>
            <CartesianGrid strokeDasharray="3 3" vertical={false} stroke="#e5e7eb" />
            <XAxis dataKey="date" tick={{ fontSize: 11, fill: "#9ca3af" }} axisLine={false} tickLine={false} />
            <YAxis yAxisId="left" tick={{ fontSize: 11, fill: "#9ca3af" }} axisLine={false} tickLine={false} />
            <YAxis yAxisId="right" orientation="right" tick={{ fontSize: 11, fill: "#9ca3af" }} axisLine={false} tickLine={false} />
            <Tooltip contentStyle={{ fontSize: 12, borderRadius: 8 }} />
            <Bar yAxisId="left" dataKey="spend" name="Spend" fill="#60a5fa" radius={[4, 4, 0, 0]} />
            <Line yAxisId="left" type="monotone" dataKey="results" name="Results" stroke="#10b981" strokeWidth={2} dot={{ r: 3 }} />
            <Line yAxisId="right" type="monotone" dataKey="cost_per_result" name="Cost per result" stroke="#d946ef" strokeWidth={2} dot={{ r: 3 }} />
          </ComposedChart>
        </ResponsiveContainer>
      </div>
    </CardShell>
  );
};

export default SimpleOverviewTab;
